import { render } from "./ExpansionCalendar.vue?vue&type=template&id=047e2d06&scoped=true"
import script from "./ExpansionCalendar.vue?vue&type=script&lang=js"
export * from "./ExpansionCalendar.vue?vue&type=script&lang=js"

import "./ExpansionCalendar.vue?vue&type=style&index=0&id=047e2d06&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047e2d06"]])

export default __exports__